module.exports = __webpack_public_path__ + "Posters0008-3e8e68142080a8e54b9e8c465637e381.png";